import { createStore } from 'vuex';
import axios from 'axios';

const store = createStore({
    state: {
        funds: [],
        thematicFunds: [],
        isFundsFetched: false,
        isThematicFund: false
    },
    mutations: {
        SET_FUNDS(state, funds) {
            state.funds = funds;
            state.isFundsFetched = true;
        },
        SET_THEMATIC_FUNDS(state, thematicFunds) {
          state.thematicFunds = thematicFunds;
          state.isThematicFund = true;
        },
    },
    actions: {
        async fetchFunds({ state, commit }) {
            if (state.isFundsFetched) {
                return state.funds; 
            }
            try {
                const baseURL = process.env.VUE_APP_BASE_URL;
                const response = await axios.get(`${baseURL}/wp-admin/admin-ajax.php?action=prime_fund_reco`);
                const mappedFunds = response.data.map(fund => ({
                    name: fund.s_name,
                    primeRating: fund.rating,
                    oneYearReturn: fund.yr1_ret,
                    threeYearCAGR: fund.yr3_ret,
                    fiveYearCAGR: fund.yr5_ret,
                    type: fund.category,
                    subCategory: fund.sub_category,
                    schemeCode: fund.schemecode,
                    comment: fund.comment,
                    category: fund.category,
                    newFlag: fund.newFlag,
                    inWatchlist: fund.in_watchlist,
                    schemeStrategy: fund.scheme_strategy,
                    theme: fund.theme,
                    trial: fund.trial_user_check || 0
                }));
                commit('SET_FUNDS', mappedFunds);
                return mappedFunds;
            } catch (error) {
                    console.error('Error fetching funds from API:', error);
                    throw error; 
            }
        },
        async fetchThematicFunds({ state, commit }) {
          if (state.isThematicFund) {
            return state.thematicFunds;
          }
          try {
            const baseURL = process.env.VUE_APP_BASE_URL;
            const response = await axios.get(
              `${baseURL}/wp-admin/admin-ajax.php?action=prime_fund_past_theme`
            );
            const mappedThematicFunds = response.data.map((thematicFund) => ({
              schemeDetails: thematicFund.scheme_details,
              thematic: thematicFund.theme,
              entryReco: thematicFund.Entry_Reco,
              exitReco: thematicFund.Exit_Reco,
              reports: thematicFund.Research_report,
              return: thematicFund.Returns_Percentage
            }));
            commit("SET_THEMATIC_FUNDS", mappedThematicFunds);
            return mappedThematicFunds;
          } catch (error) {
            console.error("Error fetching thematic funds from API:", error);
            throw error;
          }
        },
        
        async saveMfWatchlist({ dispatch }, schemecode) {
            try {
              const baseURL = process.env.VUE_APP_BASE_URL;
              const formData = new URLSearchParams();
              formData.append('action', 'savemfwatchlist'); 
              formData.append('schemecode', schemecode);
              const response = await fetch(`${baseURL}/wp-admin/admin-ajax.php`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData.toString(), 
              });
              const data = await response.json();
          
              if (data.status === true) {
                await dispatch('fetchFunds');
                return true;
              } else {
                return false;
              }
            } catch (error) {
              return false;
            }
          },
          

          async removemffromwatchlist({ dispatch }, schemecode) {
            try {
              const baseURL = process.env.VUE_APP_BASE_URL;
              const formData = new URLSearchParams();
              formData.append('action', 'removemffromwatchlist'); 
              formData.append('schemecode', schemecode); 
              const response = await fetch(`${baseURL}/wp-admin/admin-ajax.php`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData.toString(), 
              });
              const data = await response.json();
          
              if (data.status === true) {
                await dispatch('fetchFunds');
                return true;
              } else {
                return false;
              }
            } catch (error) {
              console.error('Failed to remove from watchlist:', error);
              return false;
            }
          }          
    },
    getters: {
        funds: (state) => state.funds,
        getEquityTableData: (state) => state.funds.filter(fund => fund.type === 'Equity'),
        getAggressiveFunds: (state) => state.funds.filter(fund => fund.type === 'Equity' && fund.subCategory === 'Aggressive'),
        getIndexAggressiveFunds: (state) => state.funds.filter(fund => fund.type === 'Equity' && fund.subCategory === 'Index-Aggressive'),
        getIndexModerateFunds: (state) => state.funds.filter(fund => fund.type === 'Equity' && fund.subCategory === 'Index-Moderate'),
        getModerateFunds: (state) => state.funds.filter(fund => fund.type === 'Equity' && fund.subCategory === 'Moderate'),
        getTurnaroundFunds: (state) => state.funds.filter(fund => fund.type === 'Equity' && fund.subCategory === 'Turnaround'),
        getThemeFunds: (state) => state.funds.filter(fund => fund.subCategory === 'Thematic-Funds'),
        getDebtTableData: (state) => state.funds.filter(fund => fund.type === 'Debt'),
        getLiquidFunds: (state) => state.funds.filter(fund => fund.type === 'Debt' && fund.subCategory === 'Liquid'),
        getLongTermFunds: (state) => state.funds.filter(fund => fund.type === 'Debt' && fund.subCategory === 'Long-Term'),
        getMediumTermFunds: (state) => state.funds.filter(fund => fund.type === 'Debt' && fund.subCategory === 'Medium-Term'),
        getShortTermFunds: (state) => state.funds.filter(fund => fund.type === 'Debt' && fund.subCategory === 'Short-Term'),
        getVeryShortTermFunds: (state) => state.funds.filter(fund => fund.type === 'Debt' && fund.subCategory === 'Very-Short-Term'),
        getLowRiskFunds: (state) => state.funds.filter(fund => fund.type === 'Hybrid' && fund.subCategory === 'Equity-Low-Risk'),
        getModerateRiskFunds: (state) => state.funds.filter(fund => fund.type === 'Hybrid' && fund.subCategory === 'Equity-Moderate-Risk'),
        getThematicFunds: (state) => state.thematicFunds,
    },
});

export default store;